import { render } from "./HomeView.vue?vue&type=template&id=0d01fb1e"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Jonathan\\nona\\launchxhackathon\\hackatonlaunchx\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__